<template>
    <div class="carousel-component" :class="{'is-linear-carousel':isLinearSwiper}">
        <swiper ref="mySwiper" :options="swiperOptions">
            <template v-if="swiperType === 1">
                <template v-for="(item,index) of swiperData">
                    <swiper-slide :key="(item.id || index)" :data-index="index">
                        <slot name="swiperItem" v-bind:slide="item" :index="index">
                            <div class="item-img" :class="['full-size-item']">
                                <template v-if="item.src">
                                    <a :href="item.src">
                                        <img :src="item.url" >
                                    </a>
                                </template>
                                <template v-else-if="typeof item.link === 'string'">
                                    <router-link :to="item.link">
                                        <img :src="item.url" >
                                    </router-link>
                                </template>
                                <img :src="item.url" v-else>
                            </div>
                        </slot>
                    </swiper-slide>
                </template>
            </template>
            <template v-else-if="swiperType === 2">
                <swiper-slide v-for="(item,index) of swiperData" :key="(item.id || index)">
                    <slot name="item" :item="item">
                        <div class="item-img" v-if="item.isAtlasList">
                            <img :src="item.img">
                            <p>{{ item.title }}</p>
                        </div>
                        <div class="item-img" v-else>
                            <template v-if="item.src">
                                <a :href="item.src">
                                    <img :src="item.url" >
                                </a>
                            </template>
                            <template v-else-if="item.link">
                                <router-link :to="item.link">
                                    <img :src="item.url" >
                                </router-link>
                            </template>
                            <img :src="item.url" v-else>
                        </div>
                    </slot>
                    <!--<template v-slot:item="item"></template>-->
                </swiper-slide>
            </template>
        </swiper>
        <slot name="carouselDesc">
            <div class="carousel-desc-container" :class="{'overlap-desc':descType === 1,'isolate-desc':descType === 2}" v-if="hasSwiperDesc">
                <template v-for="(item,index) of swiperData">
                    <p v-show="index === currSwiperIndex" class="carousel-desc-item" :key="item.id">
                        {{ item.title }}
                    </p>
                </template>
            </div>
        </slot>
        <div class="swiper-pagination" slot="pagination" v-if="isShowPaginate">
            <template v-for="(item,index) of swiperData">
                <span class="swiper-pagination-item" :class="{'active':index === currSwiperIndex}" :key="(item.id || index)" @click="changeCurrSwiper(index)"></span>
            </template>
        </div>
        <slot v-if="isShowNav" name="navigation">
            <div class="swiper-button-container" :class="{'user-define':!isShowDefaultNav}">
                <div class="swiper-button-prev" :class="'swiper-button-prev' + swiperIndex"></div>
                <div class="swiper-button-next" :class="'swiper-button-next' + swiperIndex"></div>
            </div>
        </slot>
    </div>
</template>
<script>
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    // import { Autoplay } from 'swiper/js/swiper.esm'
    import 'swiper/css/swiper.css';
    const DELAY = 5000;
    export default {
        name: "Carousel",
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        props: {
            // 1.正常轮播图，2.卡片swiper
            swiperType: {
                type: Number,
                default: 1
            },
            // 描述内容的类型
            // 1盖在banner上，2.在banner下方
            descType: Number,
            // 是否显示swiper的描述
            hasSwiperDesc: Boolean,
            // 是否显示分页器
            isShowPaginate: {
                type: Boolean,
                default: false
            },
            // 是否显示左右切换的按钮
            isShowNav: {
                type: Boolean,
                default: false
            },
            // 是否显示默认的左右切换按钮。默认不显示
            // 如果需要默认的按钮样式可以启用
            isShowDefaultNav: {
                type: Boolean,
                default: false
            },
            swiperData: {
                type: Array,
                default: () => []
            },
            autoPlay: {
                type: Boolean,
                default: false
            },
            customSwiperOpts: {
                type: Object,
                default: () => {}
            },
            swiperIndex: String,
            isLinearSwiper: {
                type: Boolean,
                default: false
            },
            // 是否让swiper自适应宽度
            isAutoW: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                currSwiperIndex: 0,
                disabledPrevBtn: true,
                disabledNextBtn: false,
                defaultSwiperOptions: {
                    watchSlidesProgress: true,
                    disableOnInteraction: false,
                    autoplay: this.autoPlay ? {
                        delay: DELAY
                    } : false,
                    // pagination: {
                    //     el: '.swiper-pagination',
                    // },
                    navigation: {
                        nextEl: '.swiper-button-next' + this.swiperIndex,
                        prevEl: '.swiper-button-prev' + this.swiperIndex,
                    },
                    on: {
                        transitionEnd: () => {
                            if(this.swiper){
                                this.currSwiperIndex = this.swiper.activeIndex;
                                if (this.currSwiperIndex >= this.swiperData.length) {
                                    this.currSwiperIndex = 0;
                                }
                                this.setNavigationBtnState();
                                this.$emit("changeswiper", this.currSwiperIndex);
                            }

                        }
                    }
                }
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.swiper = this.$refs.mySwiper.$swiper;
            })
        },
        created() {
            var opts = Object.assign({}, this.customSwiperOpts, this.defaultSwiperOptions);

            if (this.isAutoW) {
                opts.slidesPerView = "auto";
            }
            if (this.isLinearSwiper) {
                opts = Object.assign(opts, {
                    //                stopOnLastSlide: false,
                    autoplay: false
                });
            }
            if (this.swiperType == 2) {
                opts = Object.assign(opts, {
                    effect: 'coverflow',
                    slidesPerView: "auto",
                    normalizeSlideIndex: false,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 20,
                        depth: 50,
                        modifier: 2,
                        slideShadows: false
                    },
                    loop: false,
                });
            }
            this.swiperOptions = opts;
        },
        // computed: {
        //     swiper() {
        //         return this.$refs.mySwiper.$swiper
        //     }
        // },
        methods: {
            changeCurrSwiper(index) {
                this.currSwiperIndex = index;
                this.swiper.slideTo(index, 300, false);
                this.$emit("changeswiper", index);
            },
            setNavigationBtnState() {
                this.disabledPrevBtn = false;
                this.disabledNextBtn = false;
                if (this.currSwiperIndex === 0) {
                    this.disabledPrevBtn = true;
                }
                if (this.currSwiperIndex === this.swiperData.length - 1) {
                    this.disabledNextBtn = true;
                }

            }

        }
    }
</script>
<style lang="scss" scoped>
img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.swiper-container{
    height: 100%;
}
.swiper-pagination{
    bottom:40px;
    width:100%;
    left:0;
}
</style>